<div class="panel">
  @if (config().headerPanel) {
    <div class="panel-header">{{ config().headerPanel }}</div>
  }
  <ng-content />
</div>
